/**
 * Golf market / group-buy / visa-run write chips — tuples [ko, en, vi, ru].
 */

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

const golf = {
  marketAll: ['전체', 'All', 'Tất cả', 'Все'],
  marketGolf: ['골프장', 'Golf course', 'Sân golf', 'Гольф-клуб'],
  marketResort: ['리조트', 'Resort', 'Khu nghỉ dưỡng', 'Курорт'],
  marketSports: ['스포츠', 'Sports', 'Thể thao', 'Спорт'],
  marketOther: ['기타', 'Other', 'Khác', 'Другое'],
  subNamed: ['유기명', 'Named', 'Định danh', 'Именной'],
  subUnnamed: ['무기명', 'Unnamed', 'Không tên', 'Без имени'],
  subTransfer: ['양도', 'Transfer', 'Chuyển nhượng', 'Переуступка'],
  writeTypeGolf: ['골프장 회원권', 'Golf membership', 'Thẻ golf', 'Членство в гольфе'],
  writeTypeResort: ['리조트/콘도', 'Resort / condo', 'Resort / căn hộ', 'Курорт / кондо'],
  writeTypeSports: ['스포츠 클럽', 'Sports club', 'CLB thể thao', 'Спортклуб'],
  writeTypeOther: ['기타', 'Other', 'Khác', 'Другое'],
  namedOnly: ['본인만 사용 가능', 'Named holder only', 'Chỉ chủ thẻ', 'Только на имя'],
  unnamedAnyone: ['누구나 사용 가능', 'Anyone can use', 'Ai cũng dùng được', 'Может любой'],
};

const groupBuyWrite = {
  catFood: ['음식', 'Food', 'Thực phẩm', 'Еда'],
  catSupplies: ['생필품', 'Supplies', 'Đồ dùng', 'Хозтовары'],
  catBeauty: ['뷰티', 'Beauty', 'Làm đẹp', 'Красота'],
  catElectronics: ['전자', 'Electronics', 'Điện tử', 'Электроника'],
  catOther: ['기타', 'Other', 'Khác', 'Другое'],
  category: ['카테고리', 'Category', 'Danh mục', 'Категория'],
  select: ['선택', 'Select', 'Chọn', 'Выбрать'],
  currency: ['통화 선택', 'Currency', 'Tiền tệ', 'Валюта'],
  minTarget: ['최소 달성 인원', 'Minimum headcount', 'Số người tối thiểu', 'Мин. число людей'],
  minHint: ['미달성 시 자동취소', 'Auto-cancel if not reached', 'Tự huỷ nếu không đủ', 'Отмена, если не набралось'],
  autoCancelLabel: ['자동취소 여부', 'Auto-cancel', 'Tự huỷ', 'Автоотмена'],
  autoCancelHint: ['ON: 최소인원 미달성 시 자동취소', 'ON: cancel if minimum not reached', 'Bật: huỷ nếu không đủ người', 'Вкл: отмена, если минимум не набран'],
  contactHint: ['카카오톡/전화', 'KakaoTalk / phone', 'KakaoTalk / điện thoại', 'KakaoTalk / телефон'],
  contactPh: ['카카오톡 ID 또는 전화번호', 'KakaoTalk ID or phone', 'ID KakaoTalk hoặc SĐT', 'ID KakaoTalk или телефон'],
  deliveryCat: ['카테고리: {cat}', 'Category: {cat}', 'Danh mục: {cat}', 'Категория: {cat}'],
  deliveryMin: ['최소달성인원: {n}', 'Min headcount: {n}', 'Tối thiểu: {n}', 'Мин. число: {n}'],
  autoCancelOn: ['자동취소: 적용', 'Auto-cancel: on', 'Tự huỷ: bật', 'Автоотмена: вкл.'],
  autoCancelOff: ['자동취소: 미적용', 'Auto-cancel: off', 'Tự huỷ: tắt', 'Автоотмена: выкл.'],
};

const visaRun = {
  destSiemReap: ['캄보디아 씨엠립', 'Cambodia · Siem Reap', 'Campuchia · Siem Reap', 'Камбоджа · Сиемреап'],
  destPhnomPenh: ['캄보디아 프놈펜', 'Cambodia · Phnom Penh', 'Campuchia · Phnom Penh', 'Камбоджа · Пномпень'],
  destBangkok: ['태국 방콕', 'Thailand · Bangkok', 'Thái Lan · Bangkok', 'Таиланд · Бангкок'],
  destChiangMai: ['태국 치앙마이', 'Thailand · Chiang Mai', 'Thái Lan · Chiang Mai', 'Таиланд · Чиангмай'],
  destVientiane: ['라오스 비엔티안', 'Laos · Vientiane', 'Lào · Vientiane', 'Лаос · Вьентьян'],
  destMalaysia: ['말레이시아', 'Malaysia', 'Malaysia (MY)', 'Малайзия'],
  destOther: ['기타', 'Other', 'Khác', 'Другое'],
};

function buildLang(i) {
  return {
    golf: pick(golf, i),
    groupBuyWrite: pick(groupBuyWrite, i),
    visaRun: pick(visaRun, i),
  };
}

export const phaseWriteChipsKo = buildLang(0);
export const phaseWriteChipsEn = buildLang(1);
export const phaseWriteChipsVi = buildLang(2);
export const phaseWriteChipsRu = buildLang(3);
